module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/top/photo02-8279a841c266021019387bf7baff0567.png";